import { render, staticRenderFns } from "./organizationStatistics.vue?vue&type=template&id=6a7f118c&scoped=true&"
import script from "./organizationStatistics.vue?vue&type=script&lang=js&"
export * from "./organizationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./organizationStatistics.vue?vue&type=style&index=0&id=6a7f118c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7f118c",
  null
  
)

export default component.exports